import { render, staticRenderFns } from "./process-color.vue?vue&type=template&id=7621609e&scoped=true&"
import script from "./process-color.vue?vue&type=script&lang=js&"
export * from "./process-color.vue?vue&type=script&lang=js&"
import style0 from "./process-color.vue?vue&type=style&index=0&id=7621609e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7621609e",
  null
  
)

export default component.exports